import {Link} from 'react-router-dom'

export default function SettingsDrawer({ user, onClose }) {

const handleClose = () => {
    if (typeof onClose === 'function') onClose();
  };


     return (
    <aside className="settings secondary-drawer" aria-label="Settings">
      <div className="drawer-header">
        <button className="icon-btn" onClick={onClose} aria-label="Close Settings">‹</button>
        <h3>Settings</h3>
      </div>

      {user ? (
            <ul>
              <li className="active-user-account-link">
                <Link to={`/account/${user.uid}`} onClick={handleClose}>Account Settings</Link>
              </li>

              <li className="subscription-link">
                <Link to={`/subscription/${user.uid}`} onClick={handleClose}>Manage Subscription</Link>
              </li>

              <li className="notifications-link">
                <Link to={`/notificationsSettings/${user.uid}`} onClick={handleClose}>Notifications Settings</Link>
              </li>

              
              <li className="blocked-users-link">
                <Link to={`/blockedUsers/${user.uid}`} onClick={handleClose}>Blocked Users</Link>
              </li>
              <li className="how-to-use-link">
                <Link to={`/how-to-use`} onClick={handleClose}>How to use</Link>
              </li>
              <li className="viewed-users-link">
              </li>

            </ul>
          ) : (
            <ul>
              <li>No user found</li>
            </ul>
          )}
    </aside>
  );


}